import { useState } from 'react';
import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { Colors } from '../../../theme/Colors.es.js';
import { useOverflow } from '../../../hooks/useOverflow.es.js';

const Styles = labelStyles("AlertDescription", {
  root: css`
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  `,
  content: (maxLines, isOpen) => [
    css`
      // All of the properties below this are necessary
      // for line clamping to work. Even though the properties
      // have 'webkit' in them, they work cross-browser.
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: ${maxLines};
      overflow: hidden;

      > * {
        display: inline;
      }
    `,
    isOpen && css`
        label: -open;
        -webkit-line-clamp: initial;
      `
  ],
  toggle: css`
    cursor: pointer;
    textTransform: lowercase;
    color: ${Colors.blue};

    &:hover, &:focus: {
      text-decoration: underline;
    },
  `
});
const AlertDescription = ({ children, maxLines = 3 }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isOverflowing, setOverflowingNode] = useOverflow();
  const toggle = isOverflowing && jsx("button", { css: Styles.toggle, onClick: () => setIsOpen(!isOpen), type: "button", "data-zds": true }, isOpen ? "show less" : "show more");
  return jsx(
    "div",
    { css: Styles.root, "data-zds": true },
    jsx(
      "div",
      { css: Styles.content(maxLines, isOpen), ref: setOverflowingNode, "data-zds": true },
      jsx("div", { "data-zds": true }, children)
    ),
    toggle
  );
};

export { AlertDescription };
//# sourceMappingURL=AlertDescription.es.js.map
